import { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Navigate, useLocation } from "react-router-dom";
import "./Login.less";
import logo from "../../assets/logo.png";
import { getPostLoginPath, getReturnPathFromRouterState } from "../../auth/oktaUtils";

export default function OktaLogin() {
  const { authState, oktaAuth } = useOktaAuth();
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const postLoginPath = getPostLoginPath();
  const returnPath = getReturnPathFromRouterState(location.state, postLoginPath);

  if (authState === null) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="text-center" style={{ padding: "2rem" }}>
            <i className="fa fa-spinner fa-spin" style={{ fontSize: "2rem" }} />
          </div>
        </div>
      </div>
    );
  }

  if (authState.isAuthenticated) {
    return <Navigate to={returnPath} replace />;
  }

  const handleSignIn = async () => {
    setError(null);
    setIsRedirecting(true);
    try {
      oktaAuth.setOriginalUri(`${window.location.origin}${returnPath}`);
      await oktaAuth.signInWithRedirect();
    } catch (err) {
      setIsRedirecting(false);
      setError(
        err instanceof Error
          ? err.message
          : "Failed to connect to Okta. Please try again."
      );
    }
  };

  return (
    <div className="login-container">
      <div className="bg-animation">
        <div className="floating-icon icon-1">
          <i className="fa fa-heartbeat" />
        </div>
        <div className="floating-icon icon-2">
          <i className="fa fa-shield" />
        </div>
        <div className="floating-icon icon-3">
          <i className="fa fa-stethoscope" />
        </div>
        <div className="floating-icon icon-4">
          <i className="fa fa-user-md" />
        </div>
        <div className="floating-icon icon-5">
          <i className="fa fa-hospital-o" />
        </div>
        <div className="floating-icon icon-6">
          <i className="fa fa-medkit" />
        </div>
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <img src={logo} alt="ClinxOS Logo" className="logo-icon-img" />
            <h1>
              ClinxOS
              <sup style={{ fontSize: "10px", fontWeight: "600", top: "-1.3rem" }}>
                TM
              </sup>
            </h1>
          </div>
          <p className="subtitle">Secure Healthcare Data Management</p>
        </div>

        {error && (
          <div className="alert alert-danger" role="alert">
            <i className="fa fa-exclamation-triangle" />
            {error}
          </div>
        )}

        <div className="login-form">
          <button
            type="button"
            className={`btn btn-primary btn-block submit-btn ${isRedirecting ? "loading" : ""}`}
            disabled={isRedirecting}
            onClick={handleSignIn}
          >
            {isRedirecting ? (
              <span>
                <i className="fa fa-spinner fa-spin" /> Redirecting…
              </span>
            ) : (
              "Sign in with Okta"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
